
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/fine-dine-pos-billing-software",
      function () {
        return require("private-next-pages/restaurants/fine-dine-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/fine-dine-pos-billing-software"])
      });
    }
  